import { once } from './utils';

const $$links = document.querySelectorAll('a[href^="/download/"][data-platform="win"]');
const $footerBottom = document.querySelector('.footer__bottom');
const $popover = document.querySelector('.popover-download');
const isChrome = navigator.userAgent.includes('Chrome') && !navigator.userAgent.includes('OPR');

const updatePosition = () => {
  if ($footerBottom.getBoundingClientRect().top < window.innerHeight) {
    $popover.classList.add('popover-download--at-bottom');
  } else {
    $popover.classList.remove('popover-download--at-bottom');
  }
};

const showPopover = once(() => {
  $popover.classList.add('popover-download--visible');
  $popover.classList.add('popover-download--chrome');
  window.addEventListener('scroll', updatePosition);
  updatePosition();
});

if ($footerBottom && $popover && $$links.length && isChrome) {
  $$links.forEach(($link) => {
    $link.addEventListener('click', () => {
      showPopover();
    });
  });
}

if (!isChrome && $popover && $$links.length) {
  $$links.forEach(($link) => {
    $link.addEventListener('click', once(() => {
      $popover.classList.add('popover-download--visible');
      $popover.classList.add('popover-download--non-chrome');
    }));
  });
}
